import { createSelector } from 'reselect'

import { SharedState } from '../sharedState'

const translations = (state: SharedState) => state.translations

const currentLanguage = createSelector(
  [translations],
  state => state.currentLanguage,
)

export const TranslationsSelector = {
  currentLanguage,
}
